import { useEffect } from "react"
import { useSharedContext } from "Src/contexts/SharedContext"
import { isBrowser } from "Utils/Helpers"

const PageTranslationSlugs = ({ translationSlugs }) => {
  const { setTranslationSlugs } = useSharedContext()

  useEffect(() => {
    if (isBrowser) setTranslationSlugs(translationSlugs)
  }, [])

  return null
}

export default PageTranslationSlugs
